<template>
  <!---

    Developed by Saman Esmaeil @2021 - PRESENT

  -->
  <div class="hora container">
    <div class="row">
      <div
        class="col-12 col-md-11 col-xl-7 p-2 mb-2 mr-auto mx-auto"
        style="direction: rtl; font-family: IRANSansX-Regular"
      >
        <nav class="navbar">
          <div class="container-fluid">
            <div
              id="navbarNav"
              class="navbar-collapse text-center pt-3">
              <router-link
                :to="{ name: 'home' }"
                class="btn btn-sm btn-outline-success m-1"
                active-class="active"
                tag="button"
              >
                چارت جدید
              </router-link>
              <router-link
                :to="{ name: 'prashna-view' }"
                class="btn btn-sm btn-outline-primary m-1"
                active-class="active"
                tag="button"
              >
                پرشنا
              </router-link>
              <button
                class="btn btn-sm btn-outline-primary m-1"
                @click="openTutorials">
                آموزش‌های پرو
              </button>
              <router-link
                :to="{ name: 'charts' }"
                class="btn btn-sm btn-outline-secondary m-1"
                active-class="active"
                tag="button"
              >
                چارت‌ها
              </router-link>
              <router-link
                :to="{ name: 'notes' }"
                class="btn btn-sm btn-outline-secondary m-1"
                active-class="active"
                tag="button"
              >
                یادداشت‌ها
              </router-link>
              <router-link
                :to="{ name: 'settings' }"
                class="btn btn-sm btn-outline-secondary m-1"
                active-class="active"
                tag="button"
              >
                تنظیمات
              </router-link>
              <router-link
                :to="{ name: 'subscription' }"
                class="btn btn-sm btn-outline-secondary m-1"
                active-class="active"
                tag="button"
              >
                اشتراک
              </router-link>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'AppView',
  data () {
    return {}
  },
  methods: {
    openTutorials () {
      window.open('http://localhost:8083/vip-pro/', '_blank')
    }
  }
}
</script>
